import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import classes from "./ShelterPage.module.css";
import ShelterDescription from "./ShelterDescription/ShelterDescription";
import { useParams } from "react-router";
import { getShelterById } from "../../../api/firestoreData";
import LoaderScreen from "../../common/LoaderScreen/LoaderScreen";
import ScreenAlert from "../../common/ScreenAlert/ScreenAlert";
import BackButton from "../../common/BackButton";

function ShelterPage() {
  const [shelter, setShelter] = useState(null);
  const { id } = useParams();
  useEffect(() => {
    getShelterById(id).then((res) => {
      setShelter(res);
    });
  }, [id]);
  if (shelter === undefined) {
    return (
      <ScreenAlert
        severity="error"
        fontSize={50}
        message="Vyskytla sa chyba pri vyhľadaní danej nocľahárne"
      />
    );
  }
  return (
    <>
      <BackButton />
      {shelter ? (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          className={classes.grid}
        >
          <Grid item className={classes.gridItem}>
            <ShelterDescription shelterObj={shelter} />
          </Grid>
        </Grid>
      ) : (
        <LoaderScreen />
      )}
    </>
  );
}

export default ShelterPage;
